var referrer = document.referrer;
var blockedDomains = ["barska.com", "barska.wpengine.com"];

// Checking if the referrer URL is from the blocked domains
var isBlockedDomain = blockedDomains.some(domain => referrer.indexOf(domain) > -1);

// If the referrer URL is not from the blocked domains, show the age verification pop-up
if (!isBlockedDomain) {
    window.onload = function () {
        setTimeout(function () {
            if (!getCookie("visited")) {
                document.getElementById("age-overlay").style.display = "flex";
            }
        }, 1000);
    };
}


    function verifyAge(isOver18) {
        if (isOver18) {
            setCookie("visited", true, 1);
            document.getElementById("age-overlay").style.display = "none";
            // Add your code to proceed if the user is over 18
            // For example: window.location.href = "https://example.com";
        } else {
          alert("You must be over 18 to enter this site.");
            window.location.href = "https://google.com"
         
        }
    }

    function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    // Set the domain to the root domain to cover all subdomains as well
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=barska.com";
}

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }